export default __webpack_public_path__ + "static/media/scheduled-cl.9501aa98.svg";